/*
 * @Author: yangsibo
 * @Date: 2022-03-24 10:23:31
 * @LastEditors: yangsibo
 * @LastEditTime: 2023-06-03 11:30:16
 * @Description: 公用方法
 * @FilePath: /co-op.visual.com/src/utils/common.js
 */
/**
 * @description: 校验手机号
 * @Author: yangsibo
 * @Date: 2022-03-31 15:59:59
 * @param {*} rule 校验规则
 * @param {*} value 输入框value
 * @param {*} callback 校验回调
 * @param {*} flag change校验
 * @param {*} fn change回调
 * @return {*}
 */
const checkMobile = (rule, value, callback, flag, fn) => {
  if (!value) {
    return flag == "change" ? fn() : callback(new Error("请输入手机号码"));
  } else {
    var reg =
      /^1(([3,6,7,8][0-9]{9})|(4[5,7][0-9]{8})|(5[0,1,2,3,5,6,7,8,9][0-9]{8})|(7(([0,5][0-9]{8})|([1,3,6,7,8][0-9]{8})))|(9[1,8,9][0-9]{8}))$/;
    if (!reg.test(value)) {
      flag == "change" ? fn() : callback(new Error("请输入正确格式的手机号码"));
    } else {
      flag == "change" ? fn(true) : callback();
    }
  }
};
const checkIdCard = (rule, value, callback) => {
  if (value) {
    let regIdNo = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!regIdNo.test(value)) {
      callback(new Error("请输入正确格式的身份证号码"));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
/**
 * @Author: yangsibo
 * @description: 防抖
 * @Date: 2022-03-23 14:09:26
 * @param {*} fun 调用的函数
 * @param {*} delay 防抖时间
 * @return {*}
 */
let timer = null;
const debounce = (fun, delay = 100, immediate, that) => {
  return function (...arg) {
    if (timer) {
      clearInterval(timer);
    }
    //immediate 立即触发
    if (immediate && !timer) {
      fun.apply(that, [...arg]);
    }
    timer = setTimeout(() => {
      fun.apply(that, [...arg]);
    }, delay);
  };
};
/**
 * @description: 获取地址栏参数
 * @Author: juanjuanhui
 * @Date: 2023-02-27 17:46:07
 * @param {*} variable 获取参数的key
 * @return {*} 参数key所对应的值
 */
const getQueryVariable = (variable) => {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};
/**
 * @description:
 * @Author: yangsibo
 * @Date: 2022-03-31 15:59:22
 * @param {*} rule 校验规则
 * @param {*} value 输入框value
 * @param {*} callback 校验回调
 * @return {*}
 */
const checkStarLevel = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请选择机手星级"));
  } else {
    callback();
  }
};
/**
 * @description: 限制为保留两位小数点的数字格式
 * @Author: yangsibo
 * @Date: 2022-04-01 14:40:28
 * @param {String} value 需要限制的值
 * @return {String} 返回字符串格式的数字
 */
const numberLimit = (value) => {
  return (
    ("" + value) // 第一步：转成字符串
      .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
      .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
      .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
      .match(/^\d*(\.?\d{0,2})/g)[0] || ""
  ); // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
};
// 薪资类型
const typeList = {
  2: "固定工资",
  3: "计时工资",
  4: "计件工资",
};
// 2按年，3按月，4按天，5按小时，6按作业面积，7按件数
const methodList = {
  2: {
    way: "按年",
    suffix: "元/年",
  },
  3: {
    way: "按月",
    suffix: "元/月",
  },
  4: {
    way: "按天",
    suffix: "元/天",
  },
  5: {
    way: "按小时",
    suffix: "元/小时",
  },
  6: {
    way: "按作业面积",
    suffix: "元/亩",
  },
  7: {
    way: "按件数",
    suffix: "元/件",
  },
};

export const exportFile = (data, fileName, fileType) => {
  const blob = new Blob([data]);
  if ("download" in document.createElement("a")) {
    // 非IE下载
    const elink = document.createElement("a");
    elink.download = fileName + "." + fileType;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, fileName + "." + fileType);
  }
};
/**
 * @description: 获取设备信息
 * @Author: juanjuanhui
 * @Date: 2023-05-12 10:18:06
 */
export const os = () => {
  let ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook|Macintosh)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian && !isTablet;
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
    isChrome,
  };
};

/**
 * @description: 获取设备信息
 * @Author: juanjuanhui
 * @Date: 2023-05-12 10:18:06
 */
export const classOption = {
  step: 0.4, // 数值越大速度滚动越快
  limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
  hoverStop: true, // 是否开启鼠标悬停stop
  direction: 1, // 0向下 1向上 2向左 3向右
  openWatch: true, // 开启数据实时监控刷新dom
  singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
  singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
  waitTime: 2000,
};
export default {
  checkMobile,
  debounce,
  getQueryVariable,
  checkStarLevel,
  numberLimit,
  typeList,
  methodList,
  checkIdCard,
};
